<template>
  <v-dialog v-model="setDialog" persistent max-width="900px">
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <!-- <v-btn
          color="primary darken-4"
          label
          small
          dense
          dark
          @click="download(document.download)"
          class="ml-3"
        >
          <v-icon>mdi-download-circle</v-icon>Download
        </v-btn> -->
      </v-card-title>

      <v-divider></v-divider>

      <div v-if="show === true">
        <v-card-text
          v-if="document.documentFormat !== '.pdf'"
          class="overflow-y-auto overflow-x-hidden mt-3"
          style="max-height: 70vh"
        >
          <v-img class="pa-9" :src="url + document.base64Document" />
        </v-card-text>

        <v-card-text
          v-else
          class="pa-0"
          style="position: relative; background: #525659"
          :style="{
            height: isMobile ? 'auto' : '80vh',
            minHeight: isMobile ? '300px' : '700px',
            background: isMobile ? '#ffffff' : '#525659',
          }"
        >
          <!-- Loader while Blob URL is being created/loaded -->
          <div v-if="!pdfUrl" class="pa-4 white" style="height: 100%">
            <v-skeleton-loader type="image" height="100%" />
          </div>

          <template v-else>
            <!-- Mobile Optimized View -->
            <div
              v-if="isMobile"
              class="pa-12 text-center d-flex flex-column align-center justify-center"
            >
              <v-icon size="100" color="primary lighten-4"
                >mdi-file-pdf-box</v-icon
              >
              <div
                class="mt-6 grey--text text--darken-2 headline font-weight-bold"
              >
                Document Preview
              </div>
              <div class="mt-2 grey--text subtitle-1 mb-8">
                Your document is ready. Since you are on a mobile device, please
                use the button below to view it.
              </div>
              <v-btn
                x-large
                color="primary"
                class="text-none px-8 rounded-lg shadow-lg"
                @click="openPdfInNewTab"
              >
                <v-icon left>mdi-eye</v-icon>
                Open Document
              </v-btn>
              <div class="mt-4 grey--text caption">
                The document will open in your device's native PDF viewer.
              </div>
            </div>

            <!-- Desktop Iframe View -->
            <iframe
              v-else
              :src="pdfUrl"
              width="100%"
              height="100%"
              frameborder="0"
              style="border: none; display: block"
              title="Document Viewer"
              loading="lazy"
            ></iframe>
          </template>
        </v-card-text>
      </div>

      <v-card-text
        v-else
        class="overflow-y-auto overflow-x-hidden mt-3"
        style="max-height: 70vh"
      >
        <v-skeleton-loader type="image" />
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          dark
          depressed
          color="error"
          plain
          @click="(setDialog = false), (show = false)"
        >
          close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import eventMixin from "../eventMixin";

export default {
  name: "PreviewDialog",
  mixins: [eventMixin],
  props: { dialog: Boolean, document: { default: null, type: Object } },
  data() {
    return {
      show: false,
      pdfUrl: null,
    };
  },
  computed: {
    setDialog: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit("close-dialog", val);
      },
    },
    isMobile() {
      // Production-grade mobile detection
      return (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ) || window.innerWidth <= 768
      );
    },
  },
  watch: {
    document: {
      deep: true,
      handler: function (n) {
        if (n && n.length !== 0) {
          if (n.documentFormat === ".pdf" && n.download) {
            this.createPdfUrl(n.download);
          }
          setTimeout(() => {
            this.show = true;
          }, 1000);
        }
      },
    },
  },
  methods: {
    createPdfUrl(base64) {
      // Clear existing URL if any
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl);
      }

      try {
        const binaryString = window.atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([bytes], { type: "application/pdf" });
        this.pdfUrl = URL.createObjectURL(blob);
      } catch (e) {
        console.error("Error creating PDF Blob URL:", e);
        this.pdfUrl = null;
      }
    },
    /**
     * Opens PDF in a new tab - most reliable for mobile devices
     */
    openPdfInNewTab() {
      if (!this.pdfUrl) return;
      window.open(this.pdfUrl, "_blank");
    },
  },
  beforeDestroy() {
    if (this.pdfUrl) {
      URL.revokeObjectURL(this.pdfUrl);
    }
  },
};
</script>

<style scoped>
.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}
</style>
